import { render } from 'engine/index';
import { State } from 'engine/rpc';
import { lateinit } from 'shared/util';

export let playersChangeCallback: (players: { name: string; color: string }[]) => void = lateinit;

export const pieceClasses = [
	{ color: 'red', classes: 'border-red-900 bg-red-600 text-red-50' },
	{ color: 'green', classes: 'border-green-900 bg-green-600 text-green-50' },
	{ color: 'blue', classes: 'border-blue-900 bg-blue-600 text-blue-50' },
	{ color: 'yellow', classes: 'border-yellow-900 bg-yellow-500 text-yellow-950' },
	{ color: 'orange', classes: 'border-orange-800 bg-orange-600 text-orange-50' },
	{ color: 'white', classes: 'border-gray-600 bg-white text-gray-700' },
	{ color: 'cyan', classes: 'border-cyan-900 bg-cyan-600 text-cyan-50' },
	{ color: 'brown', classes: 'border-orange-600 bg-orange-800 text-orange-50' },
	{ color: 'gray', classes: 'border-gray-500 bg-gray-400 text-gray-950' },
	{ color: 'black', classes: 'border-neutral-800 bg-black text-neutral-100' },
	{ color: 'pink', classes: 'border-theme-700 bg-theme-500 text-theme-50' },
	{ color: 'purple', classes: 'border-purple-900 bg-purple-600 text-purple-50' },
];

export class PieceSelector extends Base.Component<{
	maxPlayers: number;
	colors?: string[];
	numberMode?: boolean;
	onChange: (selected: string | undefined) => void;
}> {
	override render(): HTMLElement {
		const baseClass = this.props.numberMode
			? 'group my-3 grid grid-cols-6 gap-1 md:grid-cols-10'
			: 'group my-3 grid grid-cols-3 gap-2 md:grid-cols-6';

		const view: HTMLElement = (
			<div class={baseClass} on:click={(e: MouseEvent) => this.trySelectPiece(e)}></div>
		);

		queueMicrotask(() => {
			this.props.onChange(State.color);
			if (view.childElementCount === 0) this.renderChildren([]);
		});

		// console.log('register callback');
		playersChangeCallback = this.renderChildren.bind(this);

		return view;
	}

	renderChildren(players: { name: string; color: string }[]) {
		if (this.props.numberMode == true) {
			console.log('numberOfPlayers', State.numberOfPlayers);
			const numberRange = Number.isFinite(State.numberOfPlayers) && State.numberOfPlayers > 0 ? State.numberOfPlayers : this.props.maxPlayers;
			const pieceViews = (
				<>
					{Array.from({ length: numberRange }, (_, i) => {
						const num = (i + 1).toString();
						return (
							<NumberPieceView
								reservedBy={players.find((player) => player.color === num)?.name}
								number={num}
							/>
						);
					})}
				</>
			);
			render(this.view, pieceViews);
		} else {
			const pc = this.props.colors ? this.props.colors.map((c) => pieceClasses.find((p) => p.color == c)!) : pieceClasses;

			const pieceViews = (
				<>
					{pc.slice(0, this.props.maxPlayers).map((p) => (
						<PieceView
							reservedBy={players.find((player) => player.color === p.color)?.name}
							color={p.color}
							colorClasses={p.classes}
						/>
					))}
				</>
			);

			render(this.view, pieceViews);
		}
	}

	trySelectPiece(e: MouseEvent) {
		if (!e.target || !(e.target instanceof HTMLElement)) return;
		const piece = e.target.closest('[piece]');
		if (piece) {
			const value = piece.getAttribute('color')!;
			this.props.onChange(value);
		}
	}
}

function PieceView({ color, colorClasses, reservedBy }: { color: string; colorClasses: string; reservedBy?: string }) {
	const youSelected = reservedBy === State.name && color == State.color;

	let label = reservedBy;
	if (reservedBy === '') label = 'Geen naam';
	if ((reservedBy?.length ?? 0) > 10) label = reservedBy?.slice(0, 10) + '…';

	return (
		<div
			piece
			color={color}
			data-reserved={youSelected ? undefined : reservedBy}
			data-selected={youSelected}
			class={
				colorClasses +
				' group/piece relative size-14 cursor-pointer rounded-full border transition-all data-[reserved]:pointer-events-none data-[selected]:scale-105 data-[reserved]:opacity-50 group-has-[[data-selected]]:[&:not([data-selected])]:scale-90 group-has-[[data-selected]]:[&:not([data-selected])]:opacity-70 [&:not(data-reserved)]:cursor-pointer'
			}
		>
			<div class="grid size-full content-center break-all p-1 text-center text-xs">{label}</div>
		</div>
	);
}

function NumberPieceView({ number, reservedBy }: { number: string; reservedBy?: string }) {
	const youSelected = reservedBy === State.name && number == State.color;

	let label = reservedBy;
	if (reservedBy === '') label = 'Geen naam';
	if ((reservedBy?.length ?? 0) > 8) label = reservedBy?.slice(0, 8) + '…';

	return (
		<div
			piece
			color={number}
			data-reserved={youSelected ? undefined : reservedBy}
			data-selected={youSelected}
			class="group/piece relative size-12 cursor-pointer rounded-full border-2 border-theme-600 bg-theme-500 text-theme-50 transition-all data-[reserved]:pointer-events-none data-[selected]:scale-105 data-[reserved]:opacity-50 group-has-[[data-selected]]:[&:not([data-selected])]:scale-90 group-has-[[data-selected]]:[&:not([data-selected])]:opacity-70 [&:not(data-reserved)]:cursor-pointer"
		>
			<div class="grid size-full content-center break-all p-0.5 text-center text-sm font-bold">{youSelected ? label : number}</div>
		</div>
	);
}
